import React from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'

interface Props {
  numToDelete: number
  onDelete: () => void
  hasPublished: boolean
}
const DeleteArchiveWarningDialog: React.FC<Props> = ({ numToDelete, onDelete, hasPublished }) => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)

  return (
    <Dialog
      name="delete_archive_warning"
      title={t('content.deleteScores')}
      maxWidth={400}
      okBtn={{
        disabled: hasPublished,
        text: t('action.delete'),
        action: () => {
          if (hasPublished) return false

          onDelete()
          return true
        },
      }}
      cancelBtn={{ action: () => closeDialog('delete_archive_warning') }}>
      <p>{t(getMessage(hasPublished, numToDelete))}</p>
    </Dialog>
  )
}

export default DeleteArchiveWarningDialog

const getMessage = (hasPublished: boolean, numToDelete: number) => {
  if (hasPublished) {
    if (numToDelete > 1) {
      return 'content.deletePublishedMultipleWarning'
    }
    return 'content.deletePublishedSingleWarning'
  }

  if (numToDelete > 1) {
    return 'content.deleteArchivedMultipleWarning'
  }
  return 'content.deleteArchivedSingleWarning'
}
